<template>
  <div class="privacy-agreement" data-automation="privacyAgreement">
    <div class="agreement-cont">
      <div class="agreement-header agreement-blod">{{ $t('HT.privacyAgreement.text1') }}</div>
      <div class="agreement-section">
        <p>
          {{ $t('HT.privacyAgreement.text2') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text3') }}
        </p>
      </div>

      <div class="agreement-section">
        <p>{{ $t('HT.privacyAgreement.text4') }}</p>
        <p class="agreement-red">{{ $t('HT.privacyAgreement.text5') }}</p>
        <p>{{ $t('HT.privacyAgreement.text6') }}</p>
        <p>{{ $t('HT.privacyAgreement.text7') }}</p>
        <p class="agreement-red">{{ $t('HT.privacyAgreement.text8') }}</p>
        <p>{{ $t('HT.privacyAgreement.text9') }}</p>
        <p>{{ $t('HT.privacyAgreement.text10') }}</p>
        <p>{{ $t('HT.privacyAgreement.text11') }}</p>
        <p>{{ $t('HT.privacyAgreement.text12') }}</p>
        <p>{{ $t('HT.privacyAgreement.text13') }}</p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.privacyAgreement.text14') }}</p>
        <p>
          {{ $t('HT.privacyAgreement.text15') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text16') }}
        </p>
        <p class="agreement-red">
          {{ $t('HT.privacyAgreement.text17') }}
        </p>
        <p class="agreement-red">
          {{ $t('HT.privacyAgreement.text18') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text19') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text20') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text21') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text22') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text23') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text24') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text25') }}
        </p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.privacyAgreement.text26') }}</p>
        <p>
          {{ $t('HT.privacyAgreement.text27') }}
        </p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.privacyAgreement.text28') }}</p>
        <p>
          {{ $t('HT.privacyAgreement.text29') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text30') }}
        </p>
        <p>{{ $t('HT.privacyAgreement.text31') }}</p>
        <p>{{ $t('HT.privacyAgreement.text32') }}</p>
        <p>{{ $t('HT.privacyAgreement.text33') }}</p>
        <p>{{ $t('HT.privacyAgreement.text34') }}</p>
        <p>{{ $t('HT.privacyAgreement.text35') }}</p>
        <p>{{ $t('HT.privacyAgreement.text36') }}</p>
        <p>{{ $t('HT.privacyAgreement.text37') }}</p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.privacyAgreement.text38') }}</p>
        <p>
          {{ $t('HT.privacyAgreement.text39') }}
        </p>
        <p class="agreement-red">{{ $t('HT.privacyAgreement.text40') }}</p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.privacyAgreement.text41') }}</p>
        <p>{{ $t('HT.privacyAgreement.text42') }}</p>
        <p>{{ $t('HT.privacyAgreement.text43') }}</p>
        <p>{{ $t('HT.privacyAgreement.text44') }}</p>
        <p>
          {{ $t('HT.privacyAgreement.text45') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text46') }}
        </p>
        <p>{{ $t('HT.privacyAgreement.text47') }}</p>
        <p>
          {{ $t('HT.privacyAgreement.text48') }}
        </p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.privacyAgreement.text49') }}</p>
        <p>{{ $t('HT.privacyAgreement.text50') }}</p>
        <p>{{ $t('HT.privacyAgreement.text51') }}</p>
        <p>{{ $t('HT.privacyAgreement.text52') }}</p>
        <p>
          {{ $t('HT.privacyAgreement.text53') }}
        </p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.privacyAgreement.text54') }}</p>
        <p>{{ $t('HT.privacyAgreement.text55') }}</p>
        <p>
          {{ $t('HT.privacyAgreement.text56') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text57') }}
        </p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.privacyAgreement.text58') }}</p>
        <p>{{ $t('HT.privacyAgreement.text59') }}</p>
        <p>
          {{ $t('HT.privacyAgreement.text60') }}
        </p>
        <p>
          {{ $t('HT.privacyAgreement.text61') }}
        </p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.privacyAgreement.text62') }}</p>
        <p>{{ $t('HT.privacyAgreement.text63') }}</p>
        <p>
          {{ $t('HT.privacyAgreement.text64') }}
        </p>
        <p>{{ $t('HT.privacyAgreement.text65') }}</p>
        <p>{{ $t('HT.privacyAgreement.text66') }}</p>
        <p>
          {{ $t('HT.privacyAgreement.text67') }}
        </p>
        <p>{{ $t('HT.privacyAgreement.text68') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {}
};
</script>

<style lang="scss" scoped>
.privacy-agreement {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: $color-bg-disable;

  .agreement-cont {
    width: 1200px;
    margin: 0 auto;
    color: $color-text;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }

  .agreement-header {
    padding: 64px 0 32px;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
  }

  .agreement-section {
    margin-bottom: 16px;
  }

  .agreement-blod {
    font-weight: 600;
    color: $color-title;
  }

  .agreement-red {
    color: $color-error;
  }
}
</style>
